import { Link } from 'react-router-dom';
import { tvShows } from '@/mocks/tvshows';

const hotShows = tvShows.filter((s) => s.hot);

export default function HotSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50" aria-label="热门推荐">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的精选好剧</p>
          </div>
          <Link
            to="/category/guochan"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看更多
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {hotShows.map((show) => (
            <Link
              key={show.id}
              to={`/article/${show.id}`}
              className="group"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-2.5">
                <img
                  src={show.posterImage}
                  alt={show.title}
                  title={`${show.title} - 久播影院`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-semibold bg-primary-500 text-background-50 rounded whitespace-nowrap">
                    {show.rating}
                  </span>
                </div>
                {show.status === '更新中' && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 text-[10px] bg-accent-500 text-background-50 rounded whitespace-nowrap">
                      更新中
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {show.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-0.5">{show.genres.slice(0, 2).join(' / ')}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}